import { Controller, ControllerRenderProps, useFormContext } from 'react-hook-form';
import { NumericFormat, NumericFormatProps, OnValueChange } from 'react-number-format';
import { TextField, TextFieldProps } from '@mui/material';

// ----------------------------------------------------------------------

type ControllerPropKeys = keyof ControllerRenderProps;

type Props = Omit<
  NumericFormatProps,
  'customInput' | 'onValueChange' | 'size' | 'color' | 'valueIsNumericString' | 'allowNegative' | ControllerPropKeys
> &
  Omit<TextFieldProps, 'name' | 'error' | 'helperText' | ControllerPropKeys> & { name: string };

// ----------------------------------------------------------------------

export const RHFCurrencyField = (props: Props) => {
  const { name, ...textFieldProps } = props;

  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, ref, ...fieldProps }, fieldState: { error } }) => {
        const handleValueChange: OnValueChange = ({ value }) => {
          onChange(value);
        };

        return (
          <NumericFormat
            getInputRef={ref}
            customInput={TextField}
            fullWidth
            error={!!error}
            helperText={error?.message ?? ''}
            valueIsNumericString
            allowNegative={false}
            thousandSeparator=" "
            decimalScale={2}
            decimalSeparator=","
            {...fieldProps}
            {...textFieldProps}
            onValueChange={handleValueChange}
          />
        );
      }}
    />
  );
};
